import {
  differenceInMilliseconds,
  isValid,
  parse,
  sub,
  format
} from 'date-fns';
import { StringSchema } from 'yup';
import * as Yup from 'yup';

const TODAY = new Date();
const DEFAULT_FORMAT = 'MM/dd/yyyy';
const DEFAULT_MAX_AGE = 120;
const DEFAULT_MIN_AGE = 18;

Yup.addMethod<StringSchema>(
  Yup.string,
  'dob',
  function validateDob(
    message: string,
    dateFormat: string = DEFAULT_FORMAT,
    maxAge: number = DEFAULT_MAX_AGE,
    minAge: number = DEFAULT_MIN_AGE
  ) {
    return this.test('test-dob', message, function validateDobValue(value) {
      const { path, createError } = this;

      // Validation passes when no value is sent, as this validator should not enforce `required`
      if (typeof value === 'undefined' || value === '') {
        return true;
      }

      const userDate = parse(value, dateFormat, TODAY);

      if (!isValid(userDate)) {
        return createError({ path, message });
      }

      const maxAgeDate = sub(TODAY, { years: maxAge });
      const minAgeDate = sub(TODAY, { years: minAge });

      if (differenceInMilliseconds(userDate, maxAgeDate) < 0) {
        return createError({
          path,
          message: `Please enter a birthday date that happens after ${format(
            maxAgeDate,
            dateFormat
          )}`,
        });
      }

      // Validate if the userDate is 18 years or more
      if (differenceInMilliseconds(minAgeDate, userDate) < 0) {
        return createError({
          path,
          message: `You must be ${minAge} years old or older.`,
        });
      }

      return true;
    });
  }
);

declare module 'yup' {
  interface StringSchema {
    dob(
      message: string,
      dateFormat?: string,
      maxAge?: number,
      minAge?: number
    ): StringSchema;
  }
}
